"use strict";

/* eslint-disable no-undef */
// These values are replaced by the webpack define plugin
window.__REDWOOD__API_PROXY_PATH = __REDWOOD__API_PROXY_PATH;